import React from 'react';
import { useLocation } from 'react-router-dom';

export default function GlobalBackground() {
  const location = useLocation();
  
  // No renderizar en la pantalla de login ya que tiene su propio fondo animado interactivo
  if (location.pathname.startsWith('/login')) {
    return null;
  }

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080" 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        pointerEvents: 'none',
        opacity: 1
      }}
      preserveAspectRatio="xMidYMid slice"
    >
      {/* Grupo 1: Caída continua (Capa principal) */}
      <g>
        <animateTransform attributeName="transform" type="translate" from="0,-1080" to="0,0" dur="30s" repeatCount="indefinite" />
        
        {/* Contenido (Tile Superior) */}
        <g>
          <rect x="150" y="200" width="40" height="40" fill="var(--color-primary)" opacity="0.15" />
          <rect x="300" y="800" width="60" height="60" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.2" />
          <rect x="1600" y="300" width="30" height="30" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1400" y="850" width="50" height="50" fill="var(--color-primary)" opacity="0.15" />
          <rect x="800" y="100" width="35" height="35" fill="none" stroke="var(--color-secondary)" strokeWidth="3" opacity="0.1" />
          <rect x="950" y="900" width="45" height="45" fill="var(--color-info)" opacity="0.15" />
          <rect x="50" y="500" width="25" height="25" fill="var(--color-primary)" opacity="0.1" />
          <rect x="1800" y="600" width="55" height="55" fill="none" stroke="var(--color-primary)" strokeWidth="2" opacity="0.2" />
          <rect x="600" y="650" width="30" height="30" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1200" y="450" width="40" height="40" fill="var(--color-info)" opacity="0.1" />
          <rect x="1100" y="150" width="20" height="20" fill="var(--color-primary)" opacity="0.15" />
          <rect x="400" y="400" width="50" height="50" fill="none" stroke="var(--color-info)" strokeWidth="3" opacity="0.1" />
        </g>
        {/* Duplicado para loop perfecto (Tile Inferior) */}
        <g transform="translate(0, 1080)">
          <rect x="150" y="200" width="40" height="40" fill="var(--color-primary)" opacity="0.15" />
          <rect x="300" y="800" width="60" height="60" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.2" />
          <rect x="1600" y="300" width="30" height="30" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1400" y="850" width="50" height="50" fill="var(--color-primary)" opacity="0.15" />
          <rect x="800" y="100" width="35" height="35" fill="none" stroke="var(--color-secondary)" strokeWidth="3" opacity="0.1" />
          <rect x="950" y="900" width="45" height="45" fill="var(--color-info)" opacity="0.15" />
          <rect x="50" y="500" width="25" height="25" fill="var(--color-primary)" opacity="0.1" />
          <rect x="1800" y="600" width="55" height="55" fill="none" stroke="var(--color-primary)" strokeWidth="2" opacity="0.2" />
          <rect x="600" y="650" width="30" height="30" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1200" y="450" width="40" height="40" fill="var(--color-info)" opacity="0.1" />
          <rect x="1100" y="150" width="20" height="20" fill="var(--color-primary)" opacity="0.15" />
          <rect x="400" y="400" width="50" height="50" fill="none" stroke="var(--color-info)" strokeWidth="3" opacity="0.1" />
        </g>
      </g>

      {/* Grupo 2: Caída continua (Capa de fondo, más lenta) */}
      <g>
        <animateTransform attributeName="transform" type="translate" from="0,-1080" to="0,0" dur="45s" repeatCount="indefinite" />
        
        {/* Contenido (Tile Superior) */}
        <g>
          <rect x="250" y="100" width="20" height="20" fill="var(--color-info)" opacity="0.1" />
          <rect x="1700" y="800" width="35" height="35" fill="var(--color-secondary)" opacity="0.15" />
          <rect x="750" y="350" width="45" height="45" fill="none" stroke="var(--color-primary)" strokeWidth="2" opacity="0.15" />
          <rect x="1350" y="700" width="25" height="25" fill="var(--color-info)" opacity="0.1" />
          <rect x="100" y="900" width="30" height="30" fill="var(--color-primary)" opacity="0.1" />
          <rect x="1650" y="150" width="45" height="45" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.1" />
          <rect x="900" y="600" width="35" height="35" fill="var(--color-secondary)" opacity="0.1" />
        </g>
        {/* Duplicado para loop perfecto (Tile Inferior) */}
        <g transform="translate(0, 1080)">
          <rect x="250" y="100" width="20" height="20" fill="var(--color-info)" opacity="0.1" />
          <rect x="1700" y="800" width="35" height="35" fill="var(--color-secondary)" opacity="0.15" />
          <rect x="750" y="350" width="45" height="45" fill="none" stroke="var(--color-primary)" strokeWidth="2" opacity="0.15" />
          <rect x="1350" y="700" width="25" height="25" fill="var(--color-info)" opacity="0.1" />
          <rect x="100" y="900" width="30" height="30" fill="var(--color-primary)" opacity="0.1" />
          <rect x="1650" y="150" width="45" height="45" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.1" />
          <rect x="900" y="600" width="35" height="35" fill="var(--color-secondary)" opacity="0.1" />
        </g>
      </g>

      {/* Grupo 3: Extra lluvia rápida (Capa frontal) */}
      <g>
        <animateTransform attributeName="transform" type="translate" from="0,-1080" to="0,0" dur="20s" repeatCount="indefinite" />
        
        {/* Contenido (Tile Superior) */}
        <g>
          <rect x="500" y="100" width="20" height="20" fill="var(--color-primary)" opacity="0.15" />
          <rect x="1200" y="300" width="35" height="35" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.15" />
          <rect x="200" y="700" width="45" height="45" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1500" y="800" width="25" height="25" fill="var(--color-primary)" opacity="0.1" />
          <rect x="800" y="900" width="50" height="50" fill="none" stroke="var(--color-secondary)" strokeWidth="2" opacity="0.15" />
          <rect x="1000" y="200" width="30" height="30" fill="var(--color-info)" opacity="0.15" />
          <rect x="100" y="400" width="40" height="40" fill="none" stroke="var(--color-primary)" strokeWidth="3" opacity="0.1" />
        </g>
        {/* Duplicado para loop perfecto (Tile Inferior) */}
        <g transform="translate(0, 1080)">
          <rect x="500" y="100" width="20" height="20" fill="var(--color-primary)" opacity="0.15" />
          <rect x="1200" y="300" width="35" height="35" fill="none" stroke="var(--color-info)" strokeWidth="2" opacity="0.15" />
          <rect x="200" y="700" width="45" height="45" fill="var(--color-secondary)" opacity="0.1" />
          <rect x="1500" y="800" width="25" height="25" fill="var(--color-primary)" opacity="0.1" />
          <rect x="800" y="900" width="50" height="50" fill="none" stroke="var(--color-secondary)" strokeWidth="2" opacity="0.15" />
          <rect x="1000" y="200" width="30" height="30" fill="var(--color-info)" opacity="0.15" />
          <rect x="100" y="400" width="40" height="40" fill="none" stroke="var(--color-primary)" strokeWidth="3" opacity="0.1" />
        </g>
      </g>
    </svg>
  );
}
